<div class="banner-and-form-container">
  <sms-info-banner></sms-info-banner>
  <sms-registration-error-banner></sms-registration-error-banner>
  <sms-registration-form></sms-registration-form>
</div>
